var _defs, _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNexusPanelAura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 520,
    viewBox: "0 0 1200 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Nexus dark fantasy panel aura",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "leftGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166 118) rotate(54) scale(384 492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8d477",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2563eb",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020617",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rightGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(948 110) rotate(128) scale(420 560)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38bdf8",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7c3aed",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020617",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge",
    x1: 64,
    y1: 52,
    x2: 1134,
    y2: 462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8d477",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f8d477",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#38bdf8",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f8d477",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8d477",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 520,
    fill: "url(#leftGlow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 520,
    fill: "url(#rightGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 82H1122M78 438H1122",
    stroke: "url(#edge)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 124H1038M162 396H1038",
    stroke: "#38bdf8",
    strokeOpacity: 0.14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600 66L628 104H572L600 66Z",
    fill: "#f8d477",
    fillOpacity: 0.18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M600 454L628 416H572L600 454Z",
    fill: "#f8d477",
    fillOpacity: 0.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexusPanelAura);
export default __webpack_public_path__ + "static/media/nexus-panel-aura.949f3f8602f0cabfe98c27c2ed86d9c3.svg";
export { ForwardRef as ReactComponent };